import AirtableHeader from '@ben/columbia/components/airtable-header';
import type { AirtableFetchData } from '@ben/columbia/hooks/use-mutation-airtable-fetch';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import { SectionContainer } from './styles';
import type { AirtableForm } from './types';

interface AirtableHeaderElementProps {
  form: AirtableForm;
  isScheduledVersion: boolean;
  onSuccess: (data: AirtableFetchData, id: string) => void;
  onError: () => void;
}

const AirtableHeaderElement = ({
  form,
  isScheduledVersion,
  onSuccess,
  onError,
}: AirtableHeaderElementProps) => {
  if (isScheduledVersion) {
    return null;
  }

  const defaultAirtableId = form.getValues('airtableId');

  return (
    <SectionContainer>
      <FormProvider {...form}>
        <AirtableHeader
          defaultValue={defaultAirtableId}
          onSuccess={onSuccess}
          onError={onError}
        />
      </FormProvider>
    </SectionContainer>
  );
};

export default memo(AirtableHeaderElement);
